// src/layouts/AuthLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { StyledContainer, StyledBox, FooterText } from './AuthLayout.styles';
import { AppLogo } from '@/components';

const AuthLayout: React.FC = () => {
  return (
    <StyledContainer>
      <StyledBox>
        <AppLogo src="/images/logo-2x.png" alt="WajeNexus" />
        <Outlet />
        <FooterText>
          &copy; Copyright 2025, WajeNexus - All rights reserved.
        </FooterText>
      </StyledBox>
    </StyledContainer>
  );
};

export default AuthLayout;
